var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"f-auto-resize-input"},[_vm._t("default"),_c('span',{ref:"twin",staticClass:"hidden-twin"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }